import "../styles/pages/Collaborators.css";
import { useLang } from "../context/LangContext";
import { withLangInUrl } from "../utils/i18n";

import amasyaLogo from "../logos/amasyauniversity.png";
import fixconsulting from "../logos/fixconsulting.png";
import cropped from "../logos/cropped.png";
import sahaistanbul from "../logos/sahaistanbul.png";
import corumteknopark from "../logos/çorumteknopark.png";
import tubitak from "../logos/tubitak.svg"
import gobel from "../logos/gobel.png"

const partnerAssets = [
  { key: "sahaIstanbul", logo: sahaistanbul },
  { key: "tubitak", logo: tubitak},
  { key: "corumTeknopark", logo: corumteknopark },
  { key: "amasyaUniversity", logo: amasyaLogo },
  { key: "fixConsulting", logo: fixconsulting },
  { key: "grupOfis", logo: cropped },
  { key: "gobel", logo: gobel},
];

export default function Collaborators() {
  const { dict, lang } = useLang();
  const t = dict?.collaborators ?? {};
  const partnerNames = t.partnerNames ?? {};

  const partners = partnerAssets
    .map((item) => ({
      ...item,
      name: partnerNames[item.key],
    }))
    .filter((item) => item.name);

  const handleContactClick = (e) => {
    e.preventDefault();

    const contactSection = document.getElementById("contact");

    if (!contactSection) return;

    contactSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    window.history.pushState(null, "", withLangInUrl("#contact", lang));
  };

  return (
    <section className="Collaborators-section page-section" id="collaborators">
      <div className="Collaborators-container">
        <div className="Collaborators-glow Collaborators-glow--left" />
        <div className="Collaborators-glow Collaborators-glow--right" />

        <div className="Collaborators-layout">
          <section className="Collaborators-hero">
            <h2 className="Collaborators-title">{t.title}</h2>
            <p className="Collaborators-subtitle">{t.subtitle}</p>
            <span className="Collaborators-line" />
          </section>

          {partners.length > 0 ? (
            <section
              className="Collaborators-grid"
              aria-label={t.ariaLabel}
              role="list"
            >
              {partners.map((partner) => (
                <article
                  key={partner.key}
                  className="Collaborators-card"
                  role="listitem"
                  aria-label={partner.name}
                  title={partner.name}
                  tabIndex={0}
                >
                  <div className="Collaborators-cardInner">
                    <div className="Collaborators-logoWrap">
                      <span className="Collaborators-logoGlow" />

                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="Collaborators-logo"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>

                    <div className="Collaborators-meta">
                      <span className="Collaborators-name">
                        {partner.name}
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </section>
          ) : (
            <div className="Collaborators-empty">{t.empty}</div>
          )}

          <div className="Collaborators-cta">
            <a
              className="Collaborators-button"
              href={withLangInUrl("#contact", lang)}
              onClick={handleContactClick}
            >
              {t.cta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}